import { connect } from 'react-redux';
import CollectionPage from '../pages/CollectionPage';
import { withReduxForm } from '@eb/eds-form';
import * as analytics from '@eb/site-analytics';
import { transformApiImageToImageField } from '@eb/redux-image-field';

import {
    editCollection as editCollectionAction,
    getShareUrl as getShareUrlAction,
    saveCollectionEdits as saveCollectionEditsAction,
    followCollection as followCollectionAction,
    unfollowCollection as unfollowCollectionAction,
} from '../actions/collection';

import { toggleEditMode as toggleEditModeAction } from '../actions/ui';
import { clearError as clearErrorAction } from '../actions';
import { getCreatorImage } from '../selectors';
import { collectionForm as collectionFormValidator } from '../validators';
import {
    FALLBACK_IMAGE,
    COLLECTION_PAGE_GA_CATEGORY,
    EDITORIAL_COLLECTION_PAGE_GA_CATEGORY,
} from '../constants';

const { trackEventFromState } = analytics;

const _mapStateToProps = (state) => ({
    featureFlags: state.featureFlags,
    isOwner: state.collection.canCurate,
    isQuality: state.collection.isQuality,
    isPublic: state.collection.isPublic,
    isFollowing: state.collection.isFollowing,
    collectionId: state.collection.id,
    collectionName: state.collection.name,
    collectionSummary: state.collection.summary,
    collectionImageUrl: state.collection.imageLarge
        ? state.collection.imageLarge.url
        : FALLBACK_IMAGE,
    collectionImageArtistAttribution: state.collection.artistAttribution,
    creatorName: state.collection.creator.name,
    creatorImage: getCreatorImage(state),
    collectionUser: state.collection.creator,
    displayCreatorName: state.collection.displayCreatorName,
    displayCreatorDescription: state.collection.displayCreatorDescription,
    hasError: state.hasError,
    isLoading: state.isLoading,
    shareUrl: state.collection.shareUrl,
    userId: state.userId,
    isEditMode: state.ui.isEditMode,
    initialValues: {
        ...(state.collection.imageLarge
            ? transformApiImageToImageField(
                  'imageLarge',
                  state.collection.imageLarge,
              )
            : {}),
        summary: state.collection.summary || '',
        name: state.collection.name,
    },
    trackEvent: (
        action,
        label,
        category = state.collection.isQuality
            ? EDITORIAL_COLLECTION_PAGE_GA_CATEGORY
            : COLLECTION_PAGE_GA_CATEGORY,
    ) => trackEventFromState(state, { action, label, category }),
    isGDPRCountry: state.isGDPRCountry,
});

const _mapDispatchToProps = {
    clearError: clearErrorAction,
    handleCollectionEdit: editCollectionAction,
    getShareUrl: getShareUrlAction,
    toggleEditMode: toggleEditModeAction,
    saveCollectionEdits: saveCollectionEditsAction,
    handleFollowCollection: followCollectionAction,
    handleUnfollowCollection: unfollowCollectionAction,
};

const CollectionPageWithReduxForm = withReduxForm({
    form: 'collection',
    validate: collectionFormValidator,
    useFormHooks: true,
    enableReinitialize: true,
})(CollectionPage);

export default connect(
    _mapStateToProps,
    _mapDispatchToProps,
)(CollectionPageWithReduxForm);
